import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Henna from "./pages/Henna";
import NailArt from "./pages/NailArt";
import Gallery from "./pages/Gallery";
import BuyHennaCone from "./pages/BuyHennaCone";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/henna" element={<Henna />} />
          <Route path="/nail-art" element={<NailArt />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/buy-henna-cone" element={<BuyHennaCone />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
